interface StateBlockProps {
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
}

/** Bloque centrado para estados de error o vacío. */
export function StateBlock({ title, description, action }: StateBlockProps) {
  return (
    <div className="state-block">
      <div className="state-title">{title}</div>
      {description && <div className="state-desc">{description}</div>}
      {action && (
        <div className="state-actions">
          <button type="button" className="btn btn-secondary" onClick={action.onClick}>
            {action.label}
          </button>
        </div>
      )}
    </div>
  );
}
